import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  Stack,
  Divider,
  List
} from "@mui/material";

import CollectionsTemplate from "../../../components/CollectionsTemplate/index";
import baseTheme from "../../../themes/baseTheme";
import Tooltip from "@mui/material/Tooltip";
import "../Dashboard.css";
import apiinfo from "../../../utils/base-uri.json";
import React, { useState, useImperativeHandle, useRef } from "react";

import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { styled } from '@mui/material/styles';
import "../../../Localization/i18n";
import { useTranslation } from "react-i18next";
import Status from "../../../stories/StatusComponent/StatusComponent";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import VendorStatusChange from "../Vendor/VendorStatusChange";
import VendorDetails from "../Vendor/VendorDetails";



export default function DashboardGriditem({ status, headers = [], statusRoleMap, ...props }) {

  status = statusRoleMap[status];
  const { t } = useTranslation();
  const rowPadding = "3px 0";

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  // const [view, setView] = useState(true);
  // const Viewed = () => {
  //   setView(view => !view);
  // }
  const queryParams = new URLSearchParams({
   
    vendorid: props?.vendorID || '',
  });
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>
      <Box className="mt-2" sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",

          }}
        >
          <Tooltip title={props?.vendorName} placement="top" arrow>
            <Box
              sx={{
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "250px",
              }}
            >
              <a
                variant="body2"
                style={{
                  textDecoration: "none",
                  color: "#2A93DB",
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontWeight: "600",
                }}
                href={"/vendordetails?pqid=" + props?.prequalificationId}
              >
                {props?.vendorName}
              </a>
            </Box>
          </Tooltip>
          <a
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            style={{ cursor: "pointer" }}
            className="text-muted"
          >
            <MoreVertIcon />
          </a>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="basic-menu"
          open={open}
          style={{ textAlign: "center" }}
          onClose={handleClose}
        >

          <Box sx={{ width: "150px", marginTop: "5px", marginBottom: "6px" }}>
            <a
            href={`/EditVendor?${queryParams.toString()}`}
              style={{ color: "#000", textDecoration: "none" }}
            >
              {t("Dashboard.editcompany")}
            </a>
          </Box>
          <Divider />
          <Box sx={{ width: "150px", marginTop: "5px", marginBottom: "6px" }}>
            <a
              href={"/vendordetails?pqid=" + props?.prequalificationId + "&Type=1"}
              style={{ color: "#000", textDecoration: "none" }}
            >
              {t("Dashboard.changestatus")}
            </a>
          </Box>
        </Menu>
        <Box padding={rowPadding}>
          <Typography variant="body2">
            {t("Dashboard.Submitted")}:&thinsp;
            {props?.prequalificationSubmit ? GetfVDateFormate(props?.prequalificationSubmit) : t("Dashboard.yetToSubmit")}
          </Typography>
        </Box>
        <Box padding={rowPadding}>
          <Typography variant="body2">
            {t("Dashboard.statusPeriod")}:&thinsp;
            {GetfVDateFormate(props?.prequalificationStart)}&thinsp; {t("Dashboard.to")} &thinsp;
            {GetfVDateFormate(props?.prequalificationFinish)}
          </Typography>
        </Box>
        <Box padding={rowPadding}>
          <Tooltip title={props?.clientName} placement="top" arrow>
            <Typography variant="body2" className="dashboardcontainer_ellipse">
              {t("Dashboard.client")}:&thinsp;{props?.clientName}
            </Typography>
          </Tooltip>
        </Box>
        <Box>
          <Status type={props?.prequalificationStatusId} />
        </Box>

      </Box>
    </>
  );
}
